export default [
  {
    path: '/',
    name: 'app-root',
    component: () => import('@/pages/main/auth/login'),
    meta: {
      layout: 'full',
      resource: 'AuthRoute',
      action: 'read',
      redirectIfLoggedIn: true,
      roles: ["admin", "anonymous"]
    },
  },
  {
    path: '/auth/login',
    name: 'auth-login',
    component: () => import('@/pages/main/auth/login'),
    meta: {
      layout: 'full',
      resource: 'AuthRoute',
      action: 'read',
      redirectIfLoggedIn: true,
      roles: ["admin", "anonymous"]
    },
  },
  {
    path: '/auth/forgot-password',
    name: 'auth-forgot-password',
    component: () => import('@/pages/main/auth/forgot-password'),
    meta: {
      layout: 'full',
      resource: 'AuthRoute',
      action: 'read',
      redirectIfLoggedIn: true,
      roles: ["admin", "anonymous"]
    },
  },
  {
    path: '/auth/forgot-password-mfa',
    name: 'auth-forgot-password-mfa',
    component: () => import('@/pages/main/auth/forgot-password/mfa-password-reset'),
    meta: {
      layout: 'full',
      resource: 'AuthRoute',
      action: 'read',
      redirectIfLoggedIn: true,
      roles: ["admin", "anonymous"]
    },
  },
  {
    path: '/auth/reset-password',
    name: 'auth-reset-password',
    component: () => import('@/pages/main/auth/reset-password'),
    meta: {
      layout: 'full',
      action: "read",
      resource: 'AuthRoute',
      redirectIfLoggedIn: true,
      roles: ["admin", "anonymous"]
    },
  },
  {
    path: '/auth/verify-phone',
    name: 'auth-verify-phone',
    component: () => import('@/pages/main/auth/verify-phone'),
    meta: {
      layout: 'full',
      resource: 'AuthRoute',
      action: 'read',
      // requireAuth: true,
      logPageName: "View Verify Phone Page",
      roles: ["admin"]
    },
  },
  {
    path: '/auth/account',
    name: 'auth-update-profile-account',
    component: () => import('@/pages/main/auth/profile'),
    meta: {
      action: 'read',
      resource: 'AuthRoute',
      requireAuth: true,
      logPageName: "View Profile Page",
      roles: ["admin"]
    },
  },
  {
    path: '/auth/not-authorized',
    name: 'misc-not-authorized',
    component: () => import('@/pages/main/auth/error-403'),
    meta: {
      layout: 'full',
      resource: 'AuthRoute',
      action: "read",
      roles: ["admin"]
    },
  },
  {
    path: '/auth/maintenance-mode',
    name: 'misc-under-maintenance',
    component: () => import('@/pages/main/auth/maintenance'),
    meta: {
      layout: 'full',
      action: "read",
      resource: 'AuthRoute',
      roles: ["admin"],
      redirectIfLoggedIn: true
    },
  },

  //  Security routes
  {
    path: '/security/mfa',
    name: 'security-mfa',
    component: () => import('@/pages/main/auth/security/mfa'),
    meta: {
      layout: 'full',
      resource: 'AuthRoute',
      action: 'read',
      requireAuth: true,
      roles: ["admin", "vendor", "client", "anonymous"]
    },
  },
  {
    path: '/security/mfa-authentication',
    name: 'security-mfa-authentication',
    component: () => import('@/pages/main/auth/security/authentication'),
    meta: {
      layout: 'full',
      resource: 'AuthRoute',
      action: 'read',
      redirectIfLoggedIn: true,
      roles: ["admin", "vendor", "client", "anonymous"]
    },
  },
  {
    path: '/security/mfa-activation',
    name: 'security-mfa-activation',
    component: () => import('@/pages/main/auth/security/activation'),
    meta: {
      layout: 'full',
      resource: 'AuthRoute',
      action: 'read',
      roles: ["admin", "vendor", "client", "anonymous"]
    },
  },
  {
    path: '/security/authentication-app',
    name: 'security-authentication-app',
    component: () => import('@/pages/main/auth/security/authentication-app'),
    meta: {
      layout: 'full',
      resource: 'AuthRoute',
      action: 'read',
      roles: ["admin", "vendor", "client", "anonymous"]
    },
  },
  {
    path: '/security/activation-app',
    name: 'security-activation-app',
    component: () => import('@/pages/main/auth/security/activation-app'),
    meta: {
      layout: 'full',
      resource: 'AuthRoute',
      action: 'read',
      roles: ["admin", "vendor", "client", "anonymous"]
    },
  },
  {
    path: '/security/password/expiry',
    name: 'security-password-expiry',
    component: () => import('@/pages/main/auth/password-expiration'),
    meta: {
      layout: 'full',
      resource: 'AuthRoute',
      action: 'read',
      requireAuth: true,
      roles: "admin"
    },
  },
  {
    path: '/security/password/change',
    name: 'security-password-change',
    component: () => import('@/pages/main/auth/change-password'),
    meta: {
      layout: 'full',
      resource: 'AuthRoute',
      action: 'read',
      requireAuth: true,
      roles: "admin"
    },
  },
]
